import { Collection } from "../../models/Collection";

export type GetCollectionByTitle = (title: string) => Collection | null

export const getCollectionByTitle = (openCollections: Collection[], userCollections: Collection[]): GetCollectionByTitle =>
    (title: string): Collection | null => {
        const openCollection = openCollections.find(x => x.title === title)
        if (openCollection) return openCollection

        const userCollection = userCollections.find(x => x.title === title)
        if (userCollection) return userCollection

        return null
    }